<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="item.id"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <search-station
                                class="col-4 border-right"
                                placeholder="Origin station"
                                :selectedValue.sync="item.stationOrigin"
                            >
                            </search-station>
                            <div class="col-2 border-right">
                                <core-time-input placeholder="Origin time" :time.sync="item.originTime"></core-time-input>
                            </div>
                            <search-station
                                class="col-4 border-right"
                                placeholder="Destination station"
                                :selectedValue.sync="item.stationDestination"
                            >
                            </search-station>
                            <div class="col-1">
                                <core-time-input placeholder="Destination time" :time.sync="item.destinationTime"></core-time-input>
                            </div>
                            <div class="col-1">
                                <input v-model="item.priority" type="number" class="number" placeholder="Prio" />
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add()"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: this.transportTimes,
      stations: [],
      searchQuery: null
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  props: {
    transportTimes: {
      type: Array,
      required: true
    }
  },
  watch: {
    items: {
      handler (val, oldVal) {
        if (val !== oldVal) {
          this.$emit('update:transportTimes', val)
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service/schedule/TransportTime.vue